var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0C32.3137 0 35 2.68629 35 6V29C35 32.3137 32.3137 35 29 35H25.583V25.3232L31.2285 20.8066L31.416 20.6562V8.45117C32.6498 8.21714 33.583 7.13487 33.583 5.83301C33.5828 4.3604 32.3887 3.16602 30.916 3.16602C29.4437 3.16637 28.2502 4.36062 28.25 5.83301C28.25 7.13445 29.1828 8.21569 30.416 8.4502V20.1758L24.7705 24.6924L24.583 24.8428V35H20.9277V19.5352C22.1613 19.301 23.0946 18.2186 23.0947 16.917C23.0947 15.4442 21.9005 14.25 20.4277 14.25C18.9551 14.2502 17.7607 15.4443 17.7607 16.917C17.7609 18.2185 18.6944 19.3009 19.9277 19.5352V35H16.2617V28.8682C17.4951 28.6339 18.4286 27.5515 18.4287 26.25C18.4285 24.7775 17.2342 23.5832 15.7617 23.583C14.2891 23.583 13.0949 24.7774 13.0947 26.25C13.0949 27.5516 14.0282 28.634 15.2617 28.8682V35H9.83301V30.667L9.63281 30.5166L5.16602 27.167V16.0352C6.39964 15.8012 7.33279 14.7187 7.33301 13.417C7.33301 11.9442 6.13877 10.75 4.66602 10.75C3.19352 10.7503 2 11.9444 2 13.417C2.00022 14.7184 2.93279 15.8008 4.16602 16.0352V27.667L4.36621 27.8164L8.83301 31.167V35H6C2.68629 35 8.85881e-08 32.3137 0 29V6C0 2.68629 2.68629 8.85852e-08 6 0H29Z",
    fill: "url(#paint0_linear_2149_9631)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2149_9631",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.abe771a867067cc007b4e8bcb96bce9e.svg";
export { ForwardRef as ReactComponent };